
import Vue from 'vue'
import { FieldMappingServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import '../index.less'
const fmsp = new FieldMappingServiceProxy()

export default Vue.extend({
  data(){
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      },
    }
  },
  props:{
    visible:{
      type: Boolean,
      default: false
    },
    title:{
      type: String,
      default: ''
    },
    editData:{
      type: Object,
      default: () => ({})
    }
  },
  methods:{
    handleCancel(){
      this.form.resetFields()
      this.$emit('cancel')
    },
    handleSave(){
      this.form.validateFields((err,values) => {
        if (!err) {
          if(this.editData){
            values.id = this.editData.id
          }
          fmsp.save(values).then(() =>{
            this.form.resetFields()
            this.$message.success('保存成功')
            this.$emit('saveAll')
          })
        }
      });
    }
  }
})
